import { render, staticRenderFns } from "./MomentOfferedStatListComponent.vue?vue&type=template&id=b5226e84&scoped=true&"
import script from "./MomentOfferedStatListComponent.vue?vue&type=script&lang=ts&"
export * from "./MomentOfferedStatListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MomentOfferedStatListComponent.vue?vue&type=style&index=0&id=b5226e84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5226e84",
  null
  
)

export default component.exports